import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "shared/api/firebase";
import { FaqGroupStatus } from "../types";
import { FaqGroupDB } from "./FaqGroups";

export const updateFaqGroupStatus = async (
  faqGroupId: string,
  status: FaqGroupStatus,
) => {
  const collectionRef = collection(db, "faqGroups");

  await updateDoc(doc(collectionRef, faqGroupId), {
    status,
    updatedAt: new Date(),
  });

  const faqGroupSnapshot = await getDoc(doc(collectionRef, faqGroupId));

  const updatedFaqGroup = new FaqGroupDB(faqGroupSnapshot);

  return updatedFaqGroup.toFaqGroup();
};
